var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import React from 'react';
import { styled } from "../../utils";
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
var StyledHeader = styled.header(function (_a) {
    var ghost = _a.ghost;
    return "\n    width: 100%;\n    z-index: 1000;\n    ".concat(ghost && 'position: absolute', ";\n  ");
});
var Header = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? React.createElement(Icon.MymoriaLogoDark, null) : _b, _c = _a.variant, variant = _c === void 0 ? 'ghost' : _c, children = _a.children, className = _a.className, props = __rest(_a, ["logo", "variant", "children", "className"]);
    return (React.createElement(StyledHeader, { className: className, ghost: variant === 'ghost' },
        React.createElement(HeaderMobile, __assign({ variant: variant, logo: logo }, props)),
        React.createElement(HeaderDesktop, __assign({ logo: logo }, props))));
};
export default Header;
//# sourceMappingURL=Header.js.map